export function smtpCredentialsFromForm(form) {
  return {
    smtpHost: form.smtpHost,
    smtpPort: form.smtpPort,
    smtpUser: form.smtpUser,
    smtpPass: form.smtpPass
  };
}
